<script lang="ts">
  import { Tween, type TweenedOptions } from 'svelte/motion';
  import { quintInOut } from 'svelte/easing';
  import type {AcademicState} from '../imports/builders/buildAcademic.svelte';

  import MiniPercentage from './MiniPercentage.svelte';

  let {
    dashboardState,
  }:{
    dashboardState: AcademicState
  } = $props();

  const tweenedPercentage: TweenedOptions = new Tween(0.0, {
    delay: 0,
    duration: 2000,
    easing: quintInOut,
  });
  
  $effect(()=> {
    tweenedPercentage.set(Number(dashboardState.prevScore));
  })
</script>

<MiniPercentage value={tweenedPercentage.current} polarity={'zero'} />